/**
 * Endpoint #51 — the global feed (FEED_SPEC).
 *
 * The §5.2 filter params are serialized by the view module's `viewFilterQuery`, so the two feeds
 * cannot spell a filter differently; only the scope params and the keyset cursor are added here.
 * `authorIds` is deliberately not forwarded — `groupIds`/`profileIds` replace it, and the server
 * strips it anyway.
 */

import type { GlobalFeedQuery, GlobalFeedResponse } from '@lw/shared';
import { apiJson } from './client';
import { viewFilterQuery } from './views';

export function getGlobalFeed(
  params: Partial<GlobalFeedQuery> = {},
  signal?: AbortSignal,
): Promise<GlobalFeedResponse> {
  return apiJson<GlobalFeedResponse>('/feed', {
    query: {
      ...viewFilterQuery(params),
      authorIds: undefined,
      groupIds: params.groupIds,
      profileIds: params.profileIds,
      sort: params.sort,
      dir: params.dir,
      cursor: params.cursor,
      limit: params.limit,
    },
    signal,
  });
}
